import { MOTIF_LABELS } from "./constants";

export const formatMotif = (motif: string): string =>
  MOTIF_LABELS[motif] ?? motif.replace(/[-_]/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
